import Navbar from '../navbar/Navbar';
import Footer from '../footer/Footer';
import AboutLeftTab from './AboutLeftTab'



function Policies() {
    return (
        <div>
            <Navbar />
            <div className="graduate-admission pt-lg-5 pt-4 pb-70">
                <div className="container">
                    <div className="row">
                        <AboutLeftTab />
                        <div className="col-lg-8 ps-lg-4 order-1 order-lg-2">
                            <div className="how-to-apply">
                                <h2>
                                    Policy
                                </h2>
                                <div class="detgails-right-content mt-4">
                                    <div class="related-download bg-gray">
                                        <ul>
                                            <li>
                                                <a href="https://admin.swec.ac.in/assetsswec/documents/SWEC-FACULTY-POLICY.pdf" target="_blank"><i class="fa-solid fa-file-pdf"></i> Faculty Policy </a>
                                            </li>
                                            <li>
                                                <a href="https://admin.swec.ac.in/assetsswec/documents/IQAC/IQAC-Policies-of-swec.pdf" target="_blank"><i class="fa-solid fa-file-pdf"></i> IQAC Policies of Sridevi Women  </a>
                                            </li>

                                            <li>
                                                <a href="https://admin.swec.ac.in/assetsswec/documents/Student-Centric-Policies.pdf" target='_blank'><i class="fa-solid fa-file-pdf"></i>Student Centric Policies </a>
                                            </li>
                                            <li>
                                                <a href="https://admin.swec.ac.in/assetsswec/documents/SWEC%20Service%20Rules.pdf" target='_blank'><i class="fa-solid fa-file-pdf"></i>Service Rules </a>
                                            </li>

                                        </ul>
                                    </div>
                                </div>

                            </div>
                        </div>


                    </div>
                </div>
            </div>
            <Footer />
        </div>
    )
}

export default Policies
